import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhyUs from "@/components/site/WhyUs";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import MobileCTABar from "@/components/site/MobileCTABar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <WhyUs />
        <EditorialMarquee />
        <Gallery />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
}

export default App;
